import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

const AdminLogin = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back!");
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-5">
      <div className="w-full max-w-md bg-[#141414] border border-white/10 rounded-2xl p-8" data-testid="admin-login-card">
        <div className="bg-[#FF3B30]/10 text-[#FF3B30] w-12 h-12 rounded-lg flex items-center justify-center mb-6"><Lock size={22} /></div>
        <h1 className="font-display font-black text-2xl text-white">Admin Login</h1>
        <p className="text-gray-400 text-sm mt-1">Manage your car stock and enquiries.</p>
        <form onSubmit={submit} className="space-y-5 mt-8" data-testid="admin-login-form">
          <div>
            <Label className="text-gray-300 text-sm">Email</Label>
            <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="mt-2 bg-black/40 border-white/20 focus:border-[#FF3B30] text-white" data-testid="admin-email" />
          </div>
          <div>
            <Label className="text-gray-300 text-sm">Password</Label>
            <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="mt-2 bg-black/40 border-white/20 focus:border-[#FF3B30] text-white" data-testid="admin-password" />
          </div>
          <Button type="submit" disabled={loading} className="w-full bg-[#FF3B30] hover:bg-[#FF5247] text-white font-bold h-12 rounded-md" data-testid="admin-login-submit">
            {loading ? "Signing in..." : "Sign In"}
          </Button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
